<template>
  <div>
    <b-form>
      <!-- <span>Pilih Mata Kuliah </span> -->
      <!-- <b-form-select style="width: 50%" v-model="selected" :options="options" class="ml-6"
        @change="changematkul(selected)"></b-form-select>
         -->
      <Select2 v-model="selectedValue" :options="options" @change="changematkul($event)"
        :settings="{ multiple: false, width: '100%' }" />
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      selected: null,
      options: [{ id: null, text: '--Pilih Mata Kuliah--' }],
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
    };
  },
  props: {
    changematkul: Function,
    selectedValue: String
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      await axios.get('master/courses')
        .then(response => {
          if (response.status == 200) {
            response.data.data.some((e, index) => {
              var object = { "id": e.key, "text": e.course_name }
              this.options.push(object);
              return index > e.length;
            });
          }
        })
    }
  },
  computed: {
    config() {
      let dataConfig = {
        headers: { Authotization: `Bearer ${this.dataLogin.access_token}`, 'content-Type': 'application/json' }
      }
      return dataConfig
    }
  }
}
</script>